import React from "react";
import MainLayout from '../layouts/MainLayout'
import UserInfos from '../components/UserInfos'
import { useParams } from "react-router-dom";

import ActivityDetailSection from '../components/ActivityDetailSection'

const ActivityDetails = () => {
  const { id } = useParams()

  return (
    <MainLayout>
      <div className="h-full flex flex-col">
        <div className="flex">
          <div className="flex-1">
            <h1 className="text-4xl font-semibold text-gray-800">Nom de l'activité</h1>
            <h2 className=" text-gray-400">Complétez les détails de l'activité</h2>
          </div>
          <UserInfos/>
        </div>
        <ActivityDetailSection id={id} />
      </div>
      
    </MainLayout>
  ) 
}

export default ActivityDetails